module.exports = __webpack_public_path__ + "static/baby-yoda-d42c8172b4c7cc5cbe510b1e92fa14e5.png";